import React, { useEffect, useState } from 'react';
import {useFeathers} from '../../app/util';
import { useSelector } from 'react-redux';
import {
  useParams,
} from 'react-router-dom';

import {
	LoadingSpinner,
  DataDetailToolbar,
  ElectionDatesEditor,
} from '../../components';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const ElectionDates = () => {
  const feathers = useFeathers();
  const electionKey = useParams().key;
  const user = useSelector(state => state.user);
  const electionDataPreloaded = useSelector(state => state?.elections?.byKey[electionKey]);
  const [ election, setElection ] = useState(electionDataPreloaded);
  const [ electionImplementation, setElectionImplementation ] = useState(null)
  const [ loading, setLoading ] = useState(!Boolean(electionDataPreloaded));
  const history = useHistory()


  const refreshElectionData = async () => {
    try {
      const newData = await feathers.getService('elections').get(
        electionKey
      );
      setElection(newData)
      const eiData = await feathers.getService('election-implementations').get(electionKey);
      setElectionImplementation(eiData)

      setLoading(false)
    } catch(err) {
      console.error(err)
    }
  }

  const handleSave = async (changesToElection, changesToEi) => {
    await Promise.all([
      feathers.getService('elections').patch(electionKey, changesToElection),
      feathers.getService('election-implementations').patch(electionKey, changesToEi)
    ])
    history.push(`/elections/${electionKey}`)
  }

  useEffect(() => {
    if(feathers) {
      refreshElectionData()
    }
  }, [ feathers ])

  if(loading) {
    return (
      <Wrapper>
        <LoadingTile>
          <LoadingSpinner scale={0.8}/>
        </LoadingTile>
      </Wrapper>
    )
  }


  return (
    <Wrapper>
      <DataDetailToolbar
        onBack={{ to: {
            pathname: `/elections/${electionKey}`,
          }}}
        navTree={[
          {
            text: 'Elections',
            to: {
              pathname: `/elections`,
            }
          },
          {
            text: election?.name,
            to: {
							pathname: `/elections/${electionKey}`,
            }
          },
          { text: 'Edit dates' }
        ]}
      />
      <ElectionDatesEditor
        election={election}
        electionImplementation={electionImplementation}
        onSave={handleSave}
        showSaveButton={true}
        showCancelButton={false}
      />
    </Wrapper>
  )
}


const Wrapper = styled.div`
  width: calc(100% - 2 * 24px);
  min-height: calc(100% - 24px * 2);
  display: flex;
  flex-direction: column;
  padding: 24px;
  align-items: stretch;
`;

const LoadingTile = styled.div`
  width: 100%;
  align-self: center;
  justify-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default ElectionDates;
